// extracted by mini-css-extract-plugin
export var optionGrid = "_5v-7";
export var optionList = "_5v-6";
export var questionsBlock = "_5v-9";
export var spacer = "_5v-5";
export var stepCenteredContent = "_5v-3";
export var stepInner = "_5v-0";
export var stepInnerFullWidth = "_5v-1";
export var stepInnerLockScroll = "_5v-2";
export var stepTransitionFrame = "_5v-4";
export var welcomeBlock = "_5v-8";